import React from 'react';
import { useSelector } from 'react-redux';
import useMenuRedirect from '../../hooks/useMenuRedirect';
import './styles.scss';
import { getAddonHeader } from 'utils/getAddonHeader';

const AddonHeader = () => {
  const assets = useSelector(state => state.asset);
  const { nodesSelected } = useMenuRedirect();

  const addonHeaderImg = getAddonHeader(assets, nodesSelected);

  if (!addonHeaderImg) return null;

  return (
    <img
      className="addon_header_img"
      alt={nodesSelected.code}
      src={addonHeaderImg}
    />
  );
};

export default AddonHeader;
